// RG-580 — constantes de negocio de la pantalla «Revisión de Informe - Implicado» (tareas 91 y 94).

// Tareas WFL que se visan en esta pantalla: 91 = informe inicial (versión 1); 94 = actualización (versión mayor a 1).
export const ID_TAREA_VISAR_INFORME_INICIAL = 91;
export const ID_TAREA_VISAR_ACTUALIZACION = 94;

// Largo máximo de «Comentario / Instrucción al Abogado» (idp_var_comentarioInstruccion es varchar(1000)).
export const MAX_COMENTARIO = 1000;

export const MSG_CONFIRMA_REVISION = 'Confirma revisión terminada ?';

export const MSG_AVISO_REVISION = 'Revise el informe enviado por el abogado e ingrese la Decisión de la Compañía al final.';
export const MSG_ERROR_CARGA = 'No fue posible cargar el informe pendiente de revisión.';
